var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value === null)?_c('rotating-update-icon'):(!_vm.params.value)?_c('span',{staticClass:"empty-value"},[_vm._v("—")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.params.value.toLocaleString('en'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }